// Temporary lint exclusions
/* eslint-disable no-unused-expressions */
/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */

import SubjectFinder from './SubjectFinder';
import Autocomplete from './Autocomplete';
import Storage from './Storage';
import Section from './Section';

// helpers
import _aiResults from './modules/aiResults';
import _dsIntegration from './modules/dsIntegration';
import _nsnMethods from './modules/nsnMethods';
import _results from './modules/results';
import _helpers from './modules/helpers';
import _subjectFinderIntegration from './modules/subjectFinderIntegration';
import _storageMethods from './modules/storageMethods';
import _initApp from './modules/initialiseApp';
import _snapshot from './modules/snapshot';

window.loaded = false;

export default function _subjectFinder() {
    const forms = [...document.querySelectorAll(`[data-role="page"]`)];

    if (forms.length) {
        forms.forEach((form) => {
            form.addEventListener('keyup', (e) => {
                if (e.key && e.key.match(/enter/i)) {
                    e.preventDefault();
                }
            });
        });
    }

    function initialiseSubjectFinder() {
        // get the current domain
        const globals = {};
        const { origin, search } = window.location;
        // const serviceURL = 'http://0.0.0.0:7009/QX84HOJ4'; //
        // const serviceURL = 'http://0.0.0.0:7001/n7PDfvjn';
        const serviceURL = 'https://au-1602562e.datastore.squiz.cloud';

        // storage
        const storage = new Storage('subjectFinder');

        // datastore
        let ds;
        window.userUid = false;

        // datastore
        if (origin.match(/localhost/i)) {
            // ?userid=${ id }&email=${ email }
            ds = new Datastore({
                serviceURL,
            });
        }

        // hoisting the Autocomplete instance
        let subjectInputs;
        let bestSubjectsInputs;

        // initial set
        let surveySet = false;

        /**
         * Global Subject Finder data object
         * @var {object}
         */
        const subjectFinderSkeleton = {
            version: '1.5',
            lastSection: null,
            lastPage: null,
            emailOptIn: false,
            userUid: null,
            about: {
                sectionName: 'About you',
                questions: {},
            },
            academic: {
                sectionName: 'Academic history',
                questions: {},
            },
            questions: {
                sectionName: 'Questions',
                questions: {},
            },
            results: {},
            results_keywords: [],
        };

        // set modules
        const snapshot = _snapshot();
        const helpers = _helpers();
        const dsIntegration = _dsIntegration({
            storage,
            ds,
            origin,
            serviceURL,
        });
        const aiMethods = _aiResults({
            storage,
            dsIntegration,
            helpers,
            globals,
            snapshot,
        });
        const nsnMethods = _nsnMethods({ helpers, origin });

        const resultsMethods = _results({
            aiMethods,
            dsIntegration,
            storage,
            helpers,
            origin,
        });

        const sfIntegration = _subjectFinderIntegration({
            storage,
            serviceURL,
            globals,
            aiMethods,
            // subjectInputs,
            // bestSubjectsInputs,
        });

        globals.sfIntegration = sfIntegration;

        const storageMethods = _storageMethods({ storage });
        const init = _initApp({
            search,
            sfIntegration,
            ds,
            dsIntegration,
            storage,
            aiMethods,
            subjectFinderSkeleton,
            helpers,
            globals,
            snapshot,
        });

        helpers.questionActiveState();
        helpers.scrollProgressBar();

        // subject finder
        const subjectFinder = new SubjectFinder({}, function () {
            const { isFirst, isLast } = this;

            /// ///////////////////////////////////////
            // state observer

            /**
             * this watches over all events in the application
             * from the navigation controls on the bottom to
             * the progress bar and the application load
             */
            const loadMoreResults = document.querySelector(
                `[data-role="result-loader"]`
            );

            this.observer(function () {
                // set nav control logic
                sfIntegration.navControls.bind(this)();

                // activate outer section nodes
                sfIntegration.outerSectionNodes.bind(this)();

                // scroll active nav item into view
                sfIntegration.activeProgressButtonFocus.bind(this)();

                aiMethods.buildAIPostBodyData.bind(this)(() => {
                    loadMoreResults.disabled = false;
                }, true);
            });

            /**
             * runs when the app has been initialised
             */
            this.onStart(() => {
                const loadMoreResults = document.querySelector(
                    `[data-role="result-loader"]`
                );

                const resultReloader = document.querySelector(
                    `[data-role="result-reloader"]`
                );

                const resultEmailer = document.querySelector(
                    `[data-role="subscription-card-submit"]`
                );
                // loadMoreResults.disabled = true;
                // show AI generated results in the results section
                // aiMethods.buildAIPostBodyData.bind(this)(() => {
                // loadMoreResults.disabled = false;
                // });
                loadMoreResults.addEventListener('click', () => {
                    loadMoreResults.disabled = true;
                    aiMethods.buildAIPostBodyData.bind(this)();
                });

                resultReloader.addEventListener('click', (e) => {
                    const { currentTarget } = e;

                    currentTarget.disabled = true;

                    aiMethods.buildAIPostBodyData.bind(this)(
                        () => {
                            currentTarget.disabled = false;
                        },
                        true,
                        true
                    );
                });

                resultEmailer.addEventListener('click', () => {
                    sfIntegration.applyData.bind(this)();
                });
            });

            /// ////////////////////////////////////////
            // set section/page states

            /**
             * exclude the nsn api results page, we don't
             * yet have that info until the user has
             * provided their number and the API request
             * is complete
             */
            this.exclude({
                pages: ['nsn-api-best-subject', 'best-subjects'],
            });

            /// ////////////////////////////////////////
            // get local storage & kick off

            const stored = storage.get();
            // startApp.bind(this)(stored);

            // start the application
            init.startApp.bind(this)(stored);

            // if the storage data contains best subjects data
            // enable that page
            if (stored && stored.academic.questions['best-subjects']) {
                this.include({
                    pages: ['best-subjects'],
                });
            }

            /// ////////////////////////////////////////
            // save data to local storage

            /**
             * the on continue event to save
             * user's progress data in local storage
             */
            this.onContinueBefore(() => {
                this.validate();

                nsnMethods.getNSN.bind(this)();
                storageMethods.saveData.bind(this)();
                updateDatastore.bind(this)();

                if (window.userUid && !surveySet) {
                    setSurveyId.bind(this)();
                }
            });

            /**
             * update survey id
             */
            function setSurveyId() {
                const surveyLink = document.querySelector(
                    `[data-role="survey-link"]`
                );

                surveyLink.href = `${surveyLink.href}?id=${window.userUid}`;

                surveySet = true;
            }

            /**
             * sends user-entered data to Datastore
             */
            function updateDatastore() {
                const savedData = storage.get();
                const email = savedData.about.questions['about-details']
                    ? savedData.about.questions['about-details']['users-email']
                    : null;
                const username = savedData.about.questions['about-details']
                    ? savedData.about.questions['about-details']['users-name']
                    : null;
                let storedData = null;

                if (window.userUid || savedData.userUid) {
                    dsIntegration.updateUserData.bind(this)((uid) => {
                        storedData = storage.get();
                        window.userUid = uid;
                        storedData.userUid = uid;

                        storedData.about.questions['about-details'][
                            'users-email'
                        ] = email;
                        if (username)
                            storedData.about.questions['about-details'][
                                'users-name'
                            ] = username;

                        globals.storageSnapshot = snapshot.set(storedData);

                        storage.set(storedData);
                    });

                    return;
                }

                // if (email && (!window.userUid || !savedData.userUid)) {
                //     dsIntegration.userEmailExists(email, (data) => {
                //         if (data.length) {
                //             if (!helpers.validEmail.bind(this)()) return;

                //             const userData = JSON.parse(
                //                 decodeURIComponent(data.subject_finder_data)
                //             );

                //             window.userUid = data[0].id;

                //             const surveyLink = document.querySelector(
                //                 `[data-role="survey-link"]`
                //             );

                //             // surveyLink.href = `${surveyLink.href}?id=${data[0].id}`;

                //             storage.set(
                //                 JSON.parse(
                //                     decodeURIComponent(
                //                         data[0].subject_finder_data
                //                     )
                //                 )
                //             );

                //             storedData = storage.get();

                //             const storedVersion = Number(userData.version);
                //             const currentVersion = Number(
                //                 subjectFinderSkeleton.version
                //             );

                //             console.log(
                //                 `Stored version number: ${storedVersion}`
                //             );
                //             console.log(
                //                 `Current version number: ${currentVersion}`
                //             );

                //             if (storedVersion < currentVersion) {
                //                 storage.set(subjectFinderSkeleton);

                //                 console.log(
                //                     'Version is older, restarting app.'
                //                 );

                //                 dsIntegration.updateUserData.bind(this)(() => {
                //                     window.location.reload();
                //                 });

                //                 return;
                //             }

                //             if (storedData.results.length) {
                //                 aiMethods.buildAiResults(
                //                     storedData.results,
                //                     true
                //                 );
                //             }

                //             storedData.about.questions['about-details'][
                //                 'users-email'
                //             ] = email;
                //             if (username)
                //                 storedData.about.questions['about-details'][
                //                     'users-name'
                //                 ] = username;

                //             storedData.userUid = data[0].id;

                //             globals.storageSnapshot = snapshot.set(storedData);

                //             storedData.lastPage = this.activeData.name;
                //             storedData.lastSection = this.activeData.section;

                //             storage.set(storedData);

                //             // populate fields with data from local storage
                //             sfIntegration.applyData.bind(this)();

                //             // set what pages/sections are visible
                //             sfIntegration.pageStates.bind(this)(storedData);

                //             // show/hide nodes that live outside the view
                //             // of the application
                //             sfIntegration.outerSectionNodes.bind(this)();

                //             // make sure the navigation controls display correctly
                //             sfIntegration.navControls.bind(this)();

                //             dsIntegration.updateUserData.bind(this)();

                //             return;
                //         }

                //         dsIntegration.createUserItem.bind(this)((uid) => {
                //             // No user - create new user
                //             if (uid) {
                //                 storedData = storage.get();
                //                 window.userUid = uid;
                //                 storedData.userUid = uid;

                //                 storage.set(storedData);
                //             }
                //         });
                //     });
                // } else
                if (!window.userUid || !savedData.userUid) {
                    // No User - create new user
                    dsIntegration.createUserItem.bind(this)((uid) => {
                        if (uid) {
                            storedData = storage.get();
                            window.userUid = uid;
                            storedData.userUid = uid;

                            storedData.about.questions['about-details'][
                                'users-email'
                            ] = email;
                            if (username)
                                storedData.about.questions['about-details'][
                                    'users-name'
                                ] = username;

                            globals.storageSnapshot = snapshot.set(storedData);

                            storage.set(storedData);
                        }
                    });
                }
            }

            this.onNavigateBefore(() => {
                // this.validate();

                // nsnMethods.getNSN.bind(this)();
                storageMethods.saveData.bind(this)();
                updateDatastore.bind(this)();
            });

            function backAndSkip() {
                const { name } = this.activeData;

                const questionTitle = this.active.querySelector(
                    `[data-action="focus-anchor"]`
                );

                if (questionTitle) questionTitle.focus();
            }

            this.onBack(backAndSkip);
            this.onSkip(backAndSkip);

            this.onSkipBefore(() => {
                const { name } = this.activeData;

                const nsnNumber =
                    this.active.querySelector(`[name="student-nsn"]`);

                if (name === 'your-nsn' && !nsnNumber.value)
                    nsnMethods.getNSN.bind(this)();
            });

            /**
             * when the continue button is clicked and
             * the next page has loaded
             */
            this.onContinueAfter(() => {
                const questionTitle = this.active.querySelector(
                    `[data-action="focus-anchor"]`
                );

                // if we're on the last page, set the last page as the results
                if (this.steps.indexOf(this.active) === this.steps.length - 1) {
                    const { name, section } = this.activeData;
                    const savedData = storage.get();

                    savedData.lastPage = name;
                    savedData.lastSection = section;

                    if (name !== 'your-nsn') storage.set(savedData);

                    setTimeout(() => {
                        if (window.userUid)
                            dsIntegration.updateUserData.bind(this)();
                    }, 100);
                }

                sfIntegration.saveCurrentStep.bind(this)();

                if (questionTitle) questionTitle.focus();

                setTimeout(() => {
                    document
                        .querySelector(`[data-action="focus-anchor"]`)
                        .scrollIntoView({
                            behavior: 'smooth',
                        });
                }, 0);
            });

            /**
             * on progress will fire onContinueAfter
             * including after a pause has occurred
             * this is to make sure that anything in
             * on continue after isn't re-run when
             * it has already run
             */
            this.onProgress(() => {
                setTimeout(() => {
                    const { name } = this.activeData;

                    if (name === 'nsn-api-best-subject') {
                        sfIntegration.apiBestSubjects.bind(this)();
                    }
                }, 0);
            });

            /**
             * when restarting the application
             */
            this.onRestart(() => {
                // if (stored) {
                const queryParams = search.split(/\?|&/g);
                const userid = queryParams.filter((param) =>
                    param.match(/userid=/)
                );

                window.userUid = null;

                storage.set(subjectFinderSkeleton);

                if (!userid.length) {
                    window.location.reload();
                } else {
                    const userReg = new RegExp(`${userid[0]}`, 'g');
                    window.location.href = `${window.location.origin}${window.location.pathname}#topOfPage`;
                }
                // }
            });

            /// ////////////////////////////////////////
            // dynamic effects

            /**
             * this section finds nodes that influence
             * what sections/pages will be shown based
             * on user input
             */
            const dynamicEffects = [
                ...document.querySelectorAll('[data-effect]'),
            ];

            dynamicEffects.forEach((effectInput) => {
                effectInput.addEventListener('click', doEffect.bind(this));
            });

            /**
             * when clicking on any node that
             * has an effect attribute assign
             * it to a function that handles that effect
             */
            function doEffect(e) {
                const { currentTarget } = e;
                const { effectName } = currentTarget.dataset;

                if (effectName === 'previous-nz-schooling') {
                    sfIntegration.setAcademicPages.bind(this)(
                        currentTarget.dataset
                    );
                }
            }
        });

        // initialise the subject finder
        subjectFinder.init();

        // initialise the auto complete library
        let subjectList = [
            { label: 'English' },
            { label: 'English for Academic Purposes' },
            { label: 'Agricultural & Horticultural Science' },
            { label: 'Business Management' },
            { label: 'Earth and Space Science' },
            { label: 'French' },
            { label: 'Science' },
            { label: 'Maths' },
            { label: 'Ancient History' },
            { label: 'Business Studies' },
            { label: 'Comupter Science' },
            { label: 'Visual Arts' },
            { label: 'Physical Education (PE)' },
            { label: 'Test &amp; test' },
        ];

        const getSubjectList = async () => {
            const subjectList = fetch(
                `${origin}/_design/integration-points/subject-finder-subject-list/get-all-subjects`
            )
                .then((response) => response.json())
                .then((data) => {
                    return data;
                });

            return subjectList;
        };

        if (window.location.hostname.indexOf('localhost') > -1) {
            globals.subjectInputs = new Autocomplete({
                data: subjectList,
                filterBy: 'label',
                input: `[data-role="fav-subject-one"]`,
                resultsOnFocus: true,
                listToggle: true,
            });

            globals.bestSubjectsInputs = new Autocomplete({
                data: subjectList,
                filterBy: 'label',
                input: `[data-role="best-subjects-search"]`,
                resultsOnFocus: true,
                listToggle: true,
            });
        } else {
            Promise.all([getSubjectList()]).then((res) => {
                subjectList = res[0];

                globals.subjectInputs = new Autocomplete({
                    data: subjectList,
                    filterBy: 'label',
                    input: `[data-role="fav-subject-one"]`,
                    resultsOnFocus: true,
                    listToggle: true,
                });

                globals.bestSubjectsInputs = new Autocomplete({
                    data: subjectList,
                    filterBy: 'label',
                    input: `[data-role="best-subjects-search"]`,
                    resultsOnFocus: true,
                    listToggle: true,
                });
            });
        }

        // remove the initial loading icon when the app is setting up
        const mainLoader = document.querySelector(
            `[data-role="subject-finder-init-load"]`
        );

        document.addEventListener('readystatechange', () => {
            if (document.readyState === 'complete' && mainLoader)
                mainLoader.remove();
        });

        // about section dynamic required fields
        setTimeout(() => {
            // const emailInput = document.querySelector(
            //     `[data-role="users-email"]`
            // );
            // const firstNameInput = document.querySelector(
            //     `[data-role="users-name"]`
            // );
            // const firstNamePlaceholder = firstNameInput.placeholder;

            // const resultsInput = document.querySelector(
            //     `[data-role="subscription-card-input"]`
            // );

            // const resultsFirstName = document.querySelector(`
            //     [data-role="subscription-card-username"]
            // `);

            // if (emailInput.value.match(/\w+@\w+\.\w+/g)) {
            //     firstNameInput.required = true;
            //     resultsFirstName.required = true;

            //     firstNameInput.placeholder = 'First name';
            //     resultsFirstName.placeholder = 'First name';
            //     resultsInput.value = emailInput.value;
            //     resultsInput.disabled = true;
            // } else {
            //     firstNameInput.required = false;
            //     resultsFirstName.required = false;

            //     firstNameInput.placeholder = firstNamePlaceholder;
            //     resultsFirstName.placeholder = firstNamePlaceholder;
            //     resultsInput.value = emailInput.value;
            //     resultsInput.disabled = false;
            // }

            // if (firstNameInput.value) {
            //     resultsFirstName.value = firstNameInput.value;
            //     resultsFirstName.disabled = true;
            // }

            // function emailInputEvent(e) {
            //     const { target } = e;

            //     if (target.value) {
            //         // firstNameInput.required = true;
            //         resultsFirstName.required = true;

            //         // firstNameInput.placeholder = 'First name';
            //         resultsFirstName.placeholder = 'First name';

            //         if (target !== resultsInput) {
            //             resultsInput.value = target.value;
            //         }

            //         // emailInput.value = target.value;

            //         return;
            //     }

            //     firstNameInput.required = false;
            //     firstNameInput.placeholder = firstNamePlaceholder;
            //     resultsFirstName.placeholder = firstNamePlaceholder;
            //     emailInput.value = '';
            //     resultsInput.value = '';
            //     resultsInput.disabled = false;
            // }

            // resultsInput.addEventListener('keyup', emailInputEvent);
            // emailInput.addEventListener('keyup', emailInputEvent);

            // function firstNameInputEvent(e) {
            //     const { target } = e;

            //     if (target.value) {
            //         if (target !== resultsFirstName) {
            //             resultsFirstName.value = target.value;
            //             resultsFirstName.disabled = true;

            //             return;
            //         }

            //         firstNameInput.value = target.value;

            //         return;
            //     }

            //     firstNameInput.value = '';
            //     resultsFirstName.value = '';
            //     resultsFirstName.disabled = false;
            // }

            // firstNameInput.addEventListener('keyup', firstNameInputEvent);
            // resultsFirstName.addEventListener('keyup', firstNameInputEvent);

            // opt in email
            // const storeEmailAbout = document.querySelector(
            //     `[data-action="store-email"]`
            // );
            const storeEmailResults = document.querySelector(
                `[data-role="subscription-save-email"]`
            );
            let currentStorage = null;

            // storeEmailAbout.addEventListener('change', (e) => {
            //     currentStorage = storage.get();

            //     currentStorage.emailOptIn = e.target.checked;

            //     storeEmailResults.checked = e.target.checked;

            //     storage.set(currentStorage);
            // });

            storeEmailResults.addEventListener('change', (e) => {
                currentStorage = storage.get();

                currentStorage.emailOptIn = e.target.checked;

                // storeEmailAbout.checked = e.target.checked;

                storage.set(currentStorage);
            });
        }, 0);
    }

    const subjectFinderExists = !!document.querySelector(
        '[data-component="subject-finder"]'
    );

    // If the module exists, do whatever we need to
    if (subjectFinderExists) {
        if (!window.loaded) {
            initialiseSubjectFinder();
            window.loaded = true;
        }
    }
}

// calls the subject finder
_subjectFinder();
/* eslint-disable */
